import {useEffect} from 'react';
import PropTypes from 'prop-types';

import {useDispatch} from 'react-redux';
import {setCookie} from 'redux-cookie';
import {Twitch} from 'mdi-material-ui';

import Button from 'components/components/Button';

const twitch = {
  baseUrl: 'https://id.twitch.tv/oauth2/authorize',
  scopes: [
    'user:read:email',
    'chat:read',
    'chat:edit',
    'channel:moderate',
    'moderation:read',
    'channel:manage:moderators',
  ],
  loginCallbackUrl: TWITCH_CALLBACK_URL,
  loginClientId: TWITCH_CLIENT_ID,
  icon: <Twitch />,
  provider: 'twitch',
  extraParams: {},
  linkText: 'Log In With Twitch',
};

/*
const youtube = {
  linkText: 'Log In With Youtube',
  baseUrl: 'https://accounts.google.com/o/oauth2/v2/auth',
  loginClientId: YOUTUBE_CLIENT_ID,
  loginCallbackUrl: YOUTUBE_CALLBACK_URL,
  icon: <Youtube />,
  provider: 'youtube',
  scopes: [
    'https://www.googleapis.com/auth/userinfo.email',
    'https://www.googleapis.com/auth/userinfo.profile',
    'https://www.googleapis.com/auth/youtube',
  ],
  extraParams: {access_type: 'offline', include_granted_scopes: 'true'},
};
*/

const BroadcasterLogin = ({hasPermissionDetails = false, onClick = () => null, linkText}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      setCookie('advSourceDomain', window.location.host, {
        path: '/',
        domain: IS_DEV ? 'localhost' : '.adv.gg',
      }),
    );
  });

  const handleClick = (e, provider) => {
    e.preventDefault();
    let url = `${provider.baseUrl}?response_type=code&client_id=${
      provider.loginClientId
    }&redirect_uri=${encodeURIComponent(provider.loginCallbackUrl)}&scope=${provider.scopes.join(
      '+',
    )}`;

    Object.entries(provider.extraParams).forEach(([key, value]) => {
      url += `&${key}=${value}`;
    });

    onClick();
    window.location.href = url;
  };

  const permissionDetails = `Your Twitch or Youtube account is used as your broadcaster 
  account on Advocate. Advocate will not send live Stream Chat and Rooms messages 
  through your account unless you choose to enable it as a chatbot. Advocate will 
  grant moderator privileges to its chatbots to enable them to post in your chat 
  unconditionally, and will not perform any other moderation actions.`;

  /* temporarily removing youtube login
  return (
    <>
      {[twitch, youtube].map((provider) => (
        <Button
          key={provider.provider}
          handleClick={(e) => handleClick(e, provider)}
          color={provider.provider}
          icon={provider.icon}
        >
          {linkText ?? provider.linkText}
        </Button>
      ))}
      {hasPermissionDetails && <h3 className="permissionDetails">{permissionDetails}</h3>}
    </>
  );
  */
  return (
    <>
      {[twitch].map((provider) => (
        <Button
          key={provider.provider}
          handleClick={(e) => handleClick(e, provider)}
          color={provider.provider}
          icon={provider.icon}
        >
          {linkText ?? provider.linkText}
        </Button>
      ))}
      {hasPermissionDetails && <h3 className="permissionDetails">{permissionDetails}</h3>}
    </>
  );
};

BroadcasterLogin.propTypes = {
  hasPermissionDetails: PropTypes.bool,
  onClick: PropTypes.func,
  linkText: PropTypes.string,
};

export default BroadcasterLogin;
